import Vue from 'vue'

export default {
    get(id) {
        return Vue.axios.get(`/settings/${id}`)
    },
    getValue(id) {
        return Vue.axios.get(`/settings/${id}/value`)
    },
    update(id, params) {
        return Vue.axios.post(`/settings/update/${id}`, params)
    },
    // create() {
    //     return Vue.aiox.post('/api/posts')
    // }
    // // etc
}
